<template>
    <div class="comissoes">
      <g-card class="card-comissoes" 
      margem="20px" 
      :expansivel="true" 
      :comecaFechado="false">
        <template #cabecalho>
            <div class="header-filtros">
                <div class="titulo-filtros-cabecalho"> Comissões </div>
                <div class="header-icons">
                <g-button
                class="trash-box"
                tipo="cinza"
                altura="35px"
                largura="45px"
                icone="icone_lixo.svg"
                tamanhoIcone="15px"
                somenteIcone
                :sombreado="false"
                v-tooltip="'Limpar filtro'"
                @click="limpar"
                />
                <g-button
                class="buscar-button-header-filtro"
                largura="150px"
                icone="icone_lupa.svg"
                negritoTexto
                tamanhoIcone="15px"
                tamanhoTexto="15px"
                altura="35px"
                gap="10px"
                :sombreado="false"
                @click="buscar()"
                >
                    BUSCAR
                </g-button>
                </div>
            </div>
        </template>

        <g-form>
            <div class="comissoes-conteudo espacamento-filtros">
                    <div class="unidade">
                        <div class="unidade-titulo titulo-conteudo-filtros"> Unidade </div>
                        <PDropDown
                            v-model="objFiltros.EmpresaId"
                            class="unidade-input input-label unidade"
                            placeholder="TODAS"
                            :options="EmpresaArray"
                            optionLabel="nome"
                            optionValue="id"
                        >
                        </PDropDown>
                    </div>

                    <!-- <div class="filial">
                        <div class="filial-titulo titulo-conteudo-filtros"> Filial </div>
                        <PDropDown
                            v-model="objFiltros.FilialId"
                            class="filial-input input-label"
                            placeholder="Selecione a filial"
                            :filter="true"
                            optionValue="id"
                            optionLabel="nomeFilial"
                            :options="filialArray"
                        />
                    </div> -->

                    <div class="tipo">
                        <div class="tipo-titulo titulo-conteudo-filtros"> Tipo </div>
                        <PDropDown
                            v-model="objFiltros.Tipo"
                            :options="tipoArray"
                            class="tipo-input input-label tipo"
                            placeholder="TODOS"
                            optionLabel="text"
                            optionValue="value"
                        />
                    </div>

                    <div class="data-periodo-consulta">
                        <div class="data-periodo-titulo titulo-conteudo-filtros"> Período </div>
                        <div class="input-data">
                            <div class="data-inicio">
                            <g-date-input
                                v-model="objFiltros.PeriodoInicio"
                                class="data-periodo-inicio-input input-label"
                                placeholderinput="Início"
                                alturainput = "40px"
                                largurainput = "100%"
                                tamanhobotao = "35px"
                                invertido
                                :dataPassadas="true"
                            ></g-date-input>
                            </div>
                            <div class="data-periodo"> à </div>
                            <div class="data-termino">
                            <g-date-input
                                v-model="objFiltros.PeriodoFinal"
                                class="data-periodo-termino-input input-label"
                                placeholderinput="Término"
                                alturainput = "40px"
                                largurainput = "100%"
                                tamanhobotao = "35px"
                                invertido
                                :dataPassadas="true"
                            ></g-date-input>
                            </div>
                        </div>
                    </div>

                    <div class="ordenacao">
                        <div class="ordenacao-titulo titulo-conteudo-filtros"> Ordenar por </div>
                        <PDropDown
                            class="ordenacao-input input-label"
                            v-model="objFiltros.TipoOrdenacao"
                            placeholder="Selecione"
                            optionLabel="text"
                            optionValue="value"
                            :options="tipoOrdenacao"
                        />
                    </div>
                </div>
            </g-form>

            <div class="buscar-button-filtro">
                <g-button
                    class="buscar-button"
                    largura="300px"
                    icone="icone_lupa.svg"
                    negritoTexto
                    tamanhoIcone="15px"
                    tamanhoTexto="15px"
                    altura="35px"
                    gap="10px"
                    :sombreado="false"
                    @click="buscar()"
                >
                BUSCAR
                </g-button>
            </div>
        </g-card>

        <g-card margem="20px" paddingDefault="0 0em 1em" :expansivel="false" :temCabecalho="false" class="card-resultado">
            <div v-if="grid" class="">
            <img
            class="icone-global-imagemfundo"
            src="@/assets/imgs/Ilustracao_erro.svg"
            />
            <div class="texto-padrao-imagemfundo">
                Verifique os filtros e clique em buscar para exibir os resultados
            </div>
            </div>

            <div v-else-if="!grid">
            <g-data-table
                Titulo="Dados do Cliente"
                altura="auto"   
                :colunas="Colunas"
                :Paginacao="true"
                :valores="documentoComissoesArray"
                :NumeroLinhas="100"
                :Filtros="Filtro"
                :EscondeColunaBotao="true"
                :campoAgrupador="'empresaCliente'"
                :campoExibicaoGrupo="'empresaCliente'"
                :temFooter="true"
                :telaComissao="true"
            >
            <template #footer >
            <div class="agrupa-resumo-final">
                <div class="componente-grupo-componentes">
                        <div class="linhas-estilo">  Total Geral Bruto: </div>
                        <div class="label-conteudo"> {{ValoresTotalGeral.somaComissaoFormatada}}  </div>
                    </div>
                    <div class="componente-grupo-componentes">
                        <div class="linhas-estilo"> Total Imposto Renda ({{ValoresTotalGeral.porcentagemIrFormatada  + '%'}}): </div>
                        <div class="label-conteudo"> {{ValoresTotalGeral.valorIRFormatado}}</div>
                    </div>
                    <div class="componente-grupo-componentes">
                        <div class="linhas-estilo"> Total ISS ({{ValoresTotalGeral.porcentagemISSFormatada  + '%'}}): </div>
                        <div class="label-conteudo"> {{ ValoresTotalGeral.valorISSFormatado }} </div>
                    </div>
                    <div class="componente-grupo-componentes">
                        <div class="linhas-estilo">  Total Geral Liquido: </div>
                        <div class="label-conteudo"> {{ ValoresTotalGeral.totalCalculadoFormatado }} </div>
                    </div>
            </div> 
            </template>

            <template #groupfooter="slotProps" >
            <div class="linhas-gridSoma">
                <g-data-table
                :valores="[{}]"
                :ehSemDados="false"
                :ehReordenavel="false"
                :colunas="[
                        {header: `Total`},
                        {header: ''},
                        {header: ''},
                        {header: ''},
                        {header: slotProps.soma.valorTitulo, alinha: 'right'},
                        {header: slotProps.soma.comissao, alinha: 'right'},
                ]"
                :esconderHeader="true"
                :esconderColunaFrozen="true"
                :Paginacao="false"
            >
        </g-data-table>
            </div>
            </template>
    </g-data-table>
</div>
    </g-card>
    </div>

</template>


<script>
import Comissoes from './Comissoes.js'
export default Comissoes
</script>

<style scoped>
.linhas-gridSoma{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 30px;
}

.input-label {
    margin-bottom: 15px;
}

:deep( tbody .p-datatable-scrollable .p-datatable-tbody){
display: none;
}

:deep(.linhas-estilo .p-column-title ){
    color: #000000de
}

.componente-grupo-componentes{
    display: flex;
    align-items: baseline;
    gap: 10px;
    
}
.Total-Final-Titulo{
    margin-bottom: 20px;
    background-color:#E6E6E6;
}

.agrupa-resumo-final{
    display: grid;
    justify-content: space-around;
    margin-top: 10px;
}


@media (min-width: 310px) {
.unidade { order: 1 }

.comissoes-conteudo {
    display: flex;
    flex-direction: column;
}

.input-label {
    width: 100%;
}

.buscar-button-filtro {
  display: flex;
  justify-content: center;
  align-items: self-end;
}
}

@media (min-width: 368px) {}

@media (min-width: 600px) {


.buscar-button-filtro {
  display: none;
}
}

@media (min-width: 801px) {
}

@media (min-width: 1025px){
    .comissoes-conteudo {
        display: grid;
        grid-template-columns: repeat(4, minmax(6em, 1fr));
        grid-template-rows: repeat(2, auto);
        gap: 15px;
    }

    .unidade { grid-area: 1 / 1 / 2 / 2; }
    .filial { grid-area: 1 / 2 / 2 / 3; }
    .tipo { grid-area: 1 / 2 / 2 / 3; }
    .data-periodo-consulta { grid-area: 1 / 3 / 2 / 4; }
    .ordenacao { grid-area: 1 / 4 / 2 / 6; }
}

@media (min-width: 1281px) {
.comissoes-conteudo {
    display: grid;
    grid-template-columns: repeat(4, minmax(6em, 1fr));
    grid-template-rows: repeat(2, auto);
    gap: 15px;
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.filial { grid-area: 1 / 2 / 2 / 3; }
.tipo { grid-area: 1 / 2 / 2 / 3; }
.data-periodo-consulta { grid-area: 1 / 3 / 2 / 4; }
.ordenacao { grid-area: 1 / 4 / 2 / 6; }
}

@media (min-width: 1700px) {
    .comissoes-conteudo {
        display: grid;
        grid-template-columns: repeat(4, minmax(6em, 1fr));
        grid-template-rows: repeat(2, auto);
        gap: 15px;
    }

    .unidade { grid-area: 1 / 1 / 2 / 2; }
    .filial { grid-area: 1 / 2 / 2 / 3; }
    .tipo { grid-area: 1 / 2 / 2 / 3; }
    .data-periodo-consulta { grid-area: 1 / 3 / 2 / 4; }
    .ordenacao { grid-area: 1 / 4 / 2 / 6; }
}
</style>